import token, { tokenToVars } from '../token';
import Dropdown from './dropdown';

export { Dropdown };
export default tokenToVars(Dropdown, token);
